import api from '../api/api';
import { toast } from 'react-toastify';

export class TestService {
  static async testMailPrimerVencimiento(): Promise<any> {
    try {
      const response = await api.get('/test/mailPrimerVencimiento');
      toast.success('Test Mail Primer Vencimiento ejecutado correctamente');
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Error al ejecutar Test Mail Primer Vencimiento';
      toast.error(message);
      throw error;
    }
  }

  static async testMailSegundoVencimiento(): Promise<any> {
    try {
      const response = await api.get('/test/mailSegundoVencimiento');
      toast.success('Test Mail Segundo Vencimiento ejecutado correctamente');
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Error al ejecutar Test Mail Segundo Vencimiento';
      toast.error(message);
      throw error;
    }
  }

  // NUEVA FUNCIÓN
  static async testMailDocumentoVencidoArea(): Promise<any> {
    try {
      const response = await api.get('/test/mailDocumentoVencidoArea');
      toast.success('Test Mail Documento Vencido Area ejecutado correctamente');
      return response.data;
    } catch (error: any) {
      const message = error.response?.data?.message || 'Error al ejecutar Test Mail Documento Vencido Area';
      toast.error(message);
      throw error;
    }
  }
}